export default __webpack_public_path__ + "static/media/header-logo.34e471c8.png";